<template>
  <div class="page" style="position: relative"></div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "web_0",
  data() {},
  methods: {},
  mounted() {
    window.open("/mst/index.html", "_self");
  },
  created() {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web_0.vue